import { useOrderContext } from '@/components/modals/SubmitOrder/helpers';

import { OrderBlockWrapper } from '../../../Common/OrderBlockWrapper';
import { PurchaseOrderNumber } from '../PurchaseOrderNumber';

import { PartialReRoof } from './components/PartialReRoof';
import { JobDetailsProps } from './types';

import styles from './JobDetails.module.scss';

export const JobDetails = ({ isPartialReRoof }: JobDetailsProps) => {
  const state = useOrderContext();

  return (
    <div data-testid="gafe-job-details">
      <span className={styles.job_details_title}>Job Details</span>

      <OrderBlockWrapper>
        <OrderBlockWrapper className={styles.job_details_inner_card}>
          <PartialReRoof isPartialReRoof={isPartialReRoof} />
          <br />

          <PurchaseOrderNumber purchaseNumber={state.order.purchaseNumber} />
        </OrderBlockWrapper>
      </OrderBlockWrapper>
    </div>
  );
};
